<div class="rotate-indication">
	<div class="message-wrapper">
		<i class="cp-icon-info space"></i><span class="space">{{'Please rotate the screen'|cpMessageTranslate}}</span>
	</div>
</div>
